<template>
  <div
    class="d-flex flex-column align-center justify-center"
    style="height:calc(100vh - 220px)"
  >
    <v-icon size="32" color="blue-grey lighten-1">mdi-magnify</v-icon>
    <p class="ma-0 pa-0 mt-3 subtitle-2 blue-grey--text text--darken-1">
      {{ $t('boards.column_empty_state_title') }}
    </p>
    <p
      class="mx-0 pa-0 mt-1 mb-3 caption blue-grey--text text-center"
      style="max-width: 300px"
    >
      {{ subtitle }}
    </p>
    <v-btn
      v-if="showCTA"
      plain
      color="blue"
      :ripple="false"
      @click="$emit('edit')"
    >
      {{ $t('boards.column_empty_state_action') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    showCTA: Boolean,
    subtitle: String,
  },
}
</script>
